module.exports = __webpack_public_path__ + "static/img/h22.4d073f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h22.jpg
// module id = 5vGJ
// module chunks = 0